const LK_Ticket = ({ color, width, height }) => {
  return (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <path d="M22 10V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v4a2 2 0 0 1 0 4v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 1 0-4ZM9 17.5l-1 1-1-1v-2l1-1 1 1v2Zm0-5l-1 1-1-1v-2l1-1 1 1v2Zm0-5l-1 1-1-1v-2l1-1 1 1v2Zm4 8.5h-2v-2h2v2Zm0-4h-2v-2h2v2Zm0-4h-2V6h2v2Zm4 8h-2v-2h2v2Zm0-4h-2v-2h2v2Zm0-4h-2V6h2v2Z" />
    </svg>
  );
};

export default LK_Ticket;
